import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { SesionService } from '../shared/services/sesion.service';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;
@Component({
  selector: 'app-crud-companias',
  templateUrl: './crud-companias.component.html',
  styleUrls: ['./crud-companias.component.css']
})
export class CrudCompaniasComponent implements OnInit {


  principalForm = this.formBuilder.group({
    CompaniaControl: new FormControl(),
    codigoCompaniaControl: new FormControl()
  });

  companias: Compania[] = new Array<Compania>();
  companiasFiltradas: Compania[] = new Array<Compania>();
  companiaSeleccionada: Compania = new Compania();
  idCompaniaBuscar = -1;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private sesionService: SesionService, private modalService: NgbModal,
    private formBuilder: FormBuilder) { }

  ngOnInit() {

    console.log(this.principalForm);
    this.listarCompanias();
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => {
        this.companias = resultado;
        this.companiasFiltradas = this.companias;
      }
    );
  }



  public filterCompanias(event) {
    this.companiasFiltradas = [];
    for (let i = 0; i < this.companias.length; i++) {
      const compania = this.companias[i];
      if (compania.nombreCompania.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.companiasFiltradas.push(compania);
      }
    }
    this.companiaSeleccionada = new Compania();
    this.companiaSeleccionada.nombreCompania = event.query;
    this.companiaSeleccionada.codigo = "";
  }

  public validarCompaniaSeleccionada() {
    if (typeof this.companiaSeleccionada == 'string') {
      const nombreCompania = this.companiaSeleccionada;
      this.companiaSeleccionada = new Compania();
      this.companiaSeleccionada.nombreCompania = nombreCompania;
    }
  }
  crearModificarCompania() {
    swal({
      title: "Procesando ",
      text: "espere un momento",
      icon: "warning",
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: {
      }
    } as any)
    this.companiaService.crearCompania(this.companiaSeleccionada).subscribe(
      resultado => {
        this.companiaSeleccionada = resultado;
        if (this.companiaSeleccionada.idCompania!=0) {
          swal("Se creo correctamente", "La compañia fue creada/modificada correctamente : \n" + this.companiaSeleccionada.nombreCompania, "success").then(function () {
            // Redirect the user
            window.location.href = "/#/solicitar-ip";
          });
        }
        else {
          swal("Se presento un error al crear/modificar la compania", ""+this.companiaSeleccionada.nombreCompania, "error").then(function () {
            // Redirect the user
            window.location.reload();
          })
        }
      }, error => {
        swal("Se presento un error de comunicación intente nuevamente", "", "error").then(function () {
          // Redirect the user
          window.location.reload();
        })
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/crud-companias/crud-companias.component.ts